export default function themeVarsConverter(theme: { [key: string]: any }) {
  return Object.keys(theme).reduce((acc: any, key) => {
    const index = key.search(/\d/)
    const newKey = '--' + key.slice(0, index) + '-' + key.slice(index)
    acc[newKey] = theme[key]
    return acc
  }, {})
}
